import { render, staticRenderFns } from "./quanxian.vue?vue&type=template&id=8fed216c&scoped=true&"
import script from "./quanxian.vue?vue&type=script&lang=ts&"
export * from "./quanxian.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fed216c",
  null
  
)

export default component.exports